// extracted by mini-css-extract-plugin
export var content = "ServicesSection-module--content--801c0";
export var icon = "ServicesSection-module--icon--f072c";
export var section = "ServicesSection-module--section--d70e1";
export var sectionTitle = "ServicesSection-module--section-title--3dc1a";
export var service = "ServicesSection-module--service--e5664";
export var services = "ServicesSection-module--services--f4d9b";
export var text = "ServicesSection-module--text--51a35";